// extracted by mini-css-extract-plugin
module.exports = {"introduction":"Introduction_introduction__1Jboq","titles":"Introduction_titles__3XBIg","buttons":"Introduction_buttons__rmdfR","profile":"Introduction_profile__2oXVP"};